import _classCallCheck from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { OptionsColor } from "../../../../Options/Classes/OptionsColor";
import { stringToAlpha } from "../../../../Utils/ColorUtils";
export var PolygonMaskDrawStroke = /*#__PURE__*/function () {
  function PolygonMaskDrawStroke() {
    _classCallCheck(this, PolygonMaskDrawStroke);
    this.color = new OptionsColor();
    this.width = 0.5;
    this.opacity = 1;
  }
  _createClass(PolygonMaskDrawStroke, [{
    key: "load",
    value: function load(data) {
      var _a;
      if (!data) {
        return;
      }
      this.color = OptionsColor.create(this.color, data.color);
      if (typeof this.color.value === "string") {
        this.opacity = (_a = stringToAlpha(this.color.value)) !== null && _a !== void 0 ? _a : this.opacity;
      }
      if (data.opacity !== undefined) {
        this.opacity = data.opacity;
      }
      if (data.width !== undefined) {
        this.width = data.width;
      }
    }
  }]);
  return PolygonMaskDrawStroke;
}();